export default function isPhoneNumberValid(phoneNumber) {
  let regex = /^[0][0-9]{9}$/;
  return regex.test(phoneNumber);
}
